import Radium from "radium";
import React from "react";

import { styles } from "@common/styles";

export interface IWelcomeProps {
  username: string;
}

class Welcome extends React.Component<IWelcomeProps> {
  public render() {
    const { username } = this.props;

    return (
      <div
        className="flexColumnContent"
        style={styles.flexColumnContent as any}
      >
        <div
          className="pageHeaderContainer"
          style={styles.pageHeaderContainer as any}
        >
          Velkommen, {username}
        </div>
        <div
          className="contentContainer"
          style={styles.contentContainer as any}
        >
          <div className="textContainer" style={styles.textContainer as any}>
            Bruk menyen for å navigere rundt i brukerportalen.
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(Welcome);
